import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from 'util';

@Pipe({
    name: 'default'
})
export class DefaultPipe implements PipeTransform {

    transform(value: any, defaultValue?: any): any {
        const defVal: any = defaultValue || 'Brak';
        return !isNullOrUndefined(value) ? value : defVal;
    }
}
